import { useState } from "react";
import { MenuItem, Select, Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const ScorecardPlaceholder = ({
  jobsWithScorecards,
  jobToBranch,
  branches,
  onCopyScorecard,
  canEdit,
}) => {
  const [selectedCopyBranch, setSelectedCopyBranch] = useState("");
  const [selectedCopyJob, setSelectedCopyJob] = useState("");
  const { t } = useTranslation();
  // Filter jobs based on the selected branch
  const filteredJobs = selectedCopyBranch
    ? jobsWithScorecards.filter((job) =>
        (jobToBranch || []).some((jtob) => jtob.branchId === selectedCopyBranch && jtob.jobId === job.jobId)
      )
    : [];

  return (
    <Box textAlign="center" mt={2}>
      <MDTypography variant="body1" color="textSecondary">
        {canEdit
          ? t("admin.scorecardPlaceholder.noKpisEdit") // if user can edit
          : t("admin.scorecardPlaceholder.noKpisView")}{" "}
      </MDTypography>

      {canEdit && branches.length > 0 && jobsWithScorecards.length > 0 && (
        <Box mt={2}>
          <MDTypography variant="body2">{t("admin.scorecardPlaceholder.copyFromJob")}</MDTypography>

          {/* Branch Dropdown */}
          <Select
            value={selectedCopyBranch}
            onChange={(e) => {
              setSelectedCopyBranch(e.target.value);
              setSelectedCopyJob(""); // Reset job selection when branch changes
            }}
            displayEmpty
            fullWidth
            disabled={!canEdit}
            sx={{ mb: 2 }}
          >
            <MenuItem value="" disabled>
              {t("admin.scorecardPlaceholder.selectBranch")}
            </MenuItem>
            {branches.map((branch) => (
              <MenuItem key={branch.branchId} value={branch.branchId}>
                {branch.branchName}
              </MenuItem>
            ))}
          </Select>

          {/* Job Dropdown */}
          <Select
            value={selectedCopyJob}
            onChange={(e) => setSelectedCopyJob(e.target.value)}
            displayEmpty
            fullWidth
            disabled={!selectedCopyBranch || !canEdit}
          >
            <MenuItem value="" disabled>
              {t("admin.scorecardPlaceholder.selectJob")}
            </MenuItem>
            {filteredJobs.map((job) => (
              <MenuItem key={job.jobId} value={job.jobId}>
                {job.jobName}
              </MenuItem>
            ))}
          </Select>

          <MDButton
            variant="contained"
            color="primary"
            disabled={!selectedCopyJob || !canEdit}
            onClick={() => onCopyScorecard(selectedCopyJob, selectedCopyBranch)}
            sx={{ mt: 2 }}
          >
            {t("admin.scorecardPlaceholder.copyScorecard")}
          </MDButton>
        </Box>
      )}
    </Box>
  );
};

ScorecardPlaceholder.propTypes = {
  jobsWithScorecards: PropTypes.array.isRequired,
  jobToBranch: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired, // Pass the list of branches for selection
  onCopyScorecard: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default ScorecardPlaceholder;
